import React, { useEffect, useState } from 'react';
import { Check, ArrowRight, Star, ShieldCheck, Zap, Layers, Printer, Clock, Lock, CreditCard, FolderOpen } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { ScrollingBanner } from '../components/ScrollingBanner';
import { PricingCard } from '../components/PricingCard';
import { FAQItem } from '../components/FAQItem';
import { motion } from 'framer-motion';
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 17,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          minutes: prev.minutes - 1,
          seconds: 59
        };else return {
          minutes: 17,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen font-sans text-gray-900 bg-white overflow-x-hidden" data-id="element-53">
      {/* ANNOUNCEMENT BAR */}
      <div className="sticky top-0 z-50 bg-[#2563EB] text-white h-11 flex items-center justify-center text-[13px] font-semibold tracking-wide shadow-md" data-id="element-54">
        ⏳ LA OFERTA EXPIRA EN:
        <span className="bg-[#1D4ED8] rounded-lg px-3 py-1 mx-2 font-bold" data-id="element-55">
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>

      <PurchaseNotification data-id="element-56" />

      {/* HERO SECTION */}
      <section className="bg-[#FBF7F0] pt-8 pb-8 md:pt-12 md:pb-12 px-4" data-id="element-57">
        <div className="max-w-6xl mx-auto" data-id="element-58">
          <div className="text-center" data-id="element-59">
            <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-6 leading-tight text-gray-900" data-id="element-60">
              Todo lo que necesitás para empezar a vender,{' '}
              <span className="text-[#2563EB]" data-id="element-61">ya resuelto</span>.
              <br className="hidden md:block" data-id="element-62" />
              <span className="text-2xl md:text-4xl block mt-4 font-bold text-gray-500" data-id="element-63">
                Sin diseñar, sin perder tiempo, sin gastar de más.
              </span>
            </h1>
            <div className="relative max-w-4xl mx-auto my-12" data-id="element-64">
              <div className="absolute inset-0 bg-[#2563EB]/10 blur-3xl rounded-full transform scale-75" data-id="element-65"></div>
              <img src="https://cdn.magicpatterns.com/uploads/nrPw2idBJNgYEXokbJaMix/proo.png" alt="Ultrapack Sublimador Mockup Principal" className="relative z-10 w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-500" data-id="element-66" />
            </div>
            <div className="max-w-3xl mx-auto" data-id="element-67">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-700 mb-6" data-id="element-68">
                Accedé a{' '}
                <span className="text-[#2563EB]" data-id="element-69">+100.000 diseños</span> listos
                para sublimar y empezá mañana mismo, incluso aunque hoy no
                tengas plancha.
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <section className="bg-white py-12 px-4" data-id="element-70">
        <div className="max-w-4xl mx-auto" data-id="element-71">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-8" data-id="element-72">
            +2.200 personas ya están generando ingresos con este pack
          </h3>
          <div className="flex flex-col items-center gap-6 max-w-2xl mx-auto" data-id="element-73">
            {['https://cdn.magicpatterns.com/uploads/nELPZ5qEL6uoHV61W7WbD7/P1.png', 'https://cdn.magicpatterns.com/uploads/cGo9geaWfZZc3TQv3XDhHK/P2.png', 'https://cdn.magicpatterns.com/uploads/a45y5LeQBGncXbUAvuviKr/P3.png'].map((src, idx) => <div key={idx} className="w-full max-w-md rounded-xl overflow-hidden shadow-lg border-2 border-gray-100" data-id="element-74">
                <img src={src} alt="Cliente satisfecho" className="w-full h-auto object-contain" data-id="element-75" />
              </div>)}
          </div>
          <p className="text-xl font-bold text-gray-900 uppercase tracking-widest mt-8 text-center" data-id="element-76">
            imprimís, sublimás, vendés.
          </p>
        </div>
      </section>

      <ScrollingBanner data-id="element-77" />

      {/* TARGET AUDIENCE */}
      <section className="bg-[#FBF7F0] py-20 px-4" data-id="element-78">
        <div className="max-w-5xl mx-auto" data-id="element-79">
          <div className="text-center mb-16" data-id="element-80">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900" data-id="element-81">
              ¿Este Ultrapack es para vos?
            </h2>
            <p className="text-xl text-gray-500" data-id="element-82">
              Fijate si te sentís identificado 👇
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-83">
            {[{
            title: 'Querés algo simple',
            text: 'No querés complicarte con cursos largos ni procesos difíciles. Buscás algo claro, fácil y listo para usar.',
            icon: <Zap className="w-8 h-8 text-[#2563EB]" data-id="element-84" />
          }, {
            title: 'Querés resultados rápidos',
            text: 'Estás cansado de postergar y necesitás empezar ahora, no algún día.',
            icon: <Clock className="w-8 h-8 text-[#2563EB]" data-id="element-85" />
          }, {
            title: 'Querés vender con propósito',
            text: 'Te importa que lo que hacés tenga sentido, valores y conecte con personas reales.',
            icon: <Star className="w-8 h-8 text-[#2563EB]" data-id="element-86" />
          }, {
            title: 'Tenés lo básico (o estás por tenerlo)',
            text: 'Con una plancha común alcanza. Y si todavía no la tenés, igual podés arrancar tomando pedidos.',
            icon: <Printer className="w-8 h-8 text-[#2563EB]" data-id="element-87" />
          }].map((item, idx) => <div key={idx} className="bg-white p-8 rounded-2xl border border-gray-200 hover:border-[#2563EB]/50 transition-colors shadow-sm" data-id="element-88">
                <div className="mb-4" data-id="element-89">{item.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-90">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-91">{item.text}</p>
              </div>)}
          </div>
          <div className="bg-[#2563EB]/10 border border-[#2563EB]/30 rounded-xl p-6 text-center max-w-3xl mx-auto" data-id="element-92">
            <p className="text-lg md:text-xl font-medium text-gray-700" data-id="element-93">
              Si te sentiste identificado con al menos 2 puntos… <br data-id="element-94" />
              <span className="text-[#2563EB] font-bold" data-id="element-95">
                👉 Este pack está hecho para vos. Arrancá simple. Arrancá ahora
                🚀
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="bg-white py-20 px-4" data-id="element-96">
        <div className="max-w-6xl mx-auto" data-id="element-97">
          <div className="text-center mb-16" data-id="element-98">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900" data-id="element-99">
              ¿Qué vas a lograr con este pack?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-100">
              Resultados claros, simples y accionables.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-101">
            {[{
            title: 'Empezar sin complicarte',
            text: 'No necesitás saber diseñar ni perder horas probando. Todo ya está hecho para que arranques directo.'
          }, {
            title: 'Vender más rápido',
            text: 'Usás diseños que ya están listos para imprimir y vender, sin fricción ni pasos innecesarios.'
          }, {
            title: 'Ahorrar tiempo y plata',
            text: 'Te evitás pagar diseñadores, cursos o pruebas que no funcionan. Acá ya tenés todo resuelto.'
          }, {
            title: 'Avanzar paso a paso',
            text: 'Podés empezar incluso sin plancha propia, tomando pedidos y validando antes de invertir más.'
          }].map((item, idx) => <div key={idx} className="bg-gray-50 p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-102">
                <div className="w-12 h-12 bg-[#2563EB] rounded-lg flex items-center justify-center mb-4 text-white font-bold text-xl" data-id="element-103">
                  {idx + 1}
                </div>
                <h3 className="text-lg font-bold mb-3 text-gray-900" data-id="element-104">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-105">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="bg-[#0F172A] text-white py-20 px-4" data-id="element-106">
        <div className="max-w-6xl mx-auto" data-id="element-107">
          <h2 className="text-4xl font-bold text-center mb-12" data-id="element-108">
            Lo que dice la gente…
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-109">
            {['https://cdn.magicpatterns.com/uploads/3GsX9BTXRsdBYZyKdHomAf/T1.png', 'https://cdn.magicpatterns.com/uploads/unqcTx11PYMGZPJrSBuXv4/T2.png', 'https://cdn.magicpatterns.com/uploads/kN3V39pjHHb2QwaTbNFNM6/T3.png', 'https://cdn.magicpatterns.com/uploads/pBeSkRRug7bpPsyLE1hJ6X/T4.png'].map((src, idx) => <div key={idx} className="rounded-xl overflow-hidden border border-[#1E293B] hover:border-[#2563EB] transition-colors duration-300" data-id="element-110">
                <img src={src} alt={`Testimonio ${idx + 1}`} className="w-full h-auto" data-id="element-111" />
              </div>)}
          </div>
          <div className="text-center" data-id="element-112">
            <a href="https://www.instagram.com/ultrapack.digital/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#2563EB] hover:text-white transition-colors font-medium" data-id="element-113">
              Si también te gustó, mandanos un mensaje a nuestro Instagram!{' '}
              <ArrowRight className="w-4 h-4" data-id="element-114" />
            </a>
          </div>
        </div>
      </section>

      {/* OBJECTIONS */}
      <section className="bg-[#FBF7F0] py-20 px-4" data-id="element-115">
        <div className="max-w-4xl mx-auto" data-id="element-116">
          <div className="text-center mb-16" data-id="element-117">
            <h2 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-118">
              Las dudas normales antes de empezar
            </h2>
            <p className="text-xl text-gray-500" data-id="element-119">
              ( y por qué no te tienen que frenar )
            </p>
          </div>
          <div className="space-y-8" data-id="element-120">
            {[{
            q: 'Siento que no estoy listo todavía',
            a: 'La mayoría empieza sin estar listo. Este pack está pensado justamente para eso: para que no tengas que saber, ni pensar, ni improvisar. Arrancás con todo servido.'
          }, {
            q: 'No tengo tiempo para aprender algo nuevo',
            a: 'No es un curso, no es teoría, no es estudio. Es elegir un diseño, imprimirlo y vender. Mientras otros aprenden, vos avanzás.'
          }, {
            q: '¿Y si no vendo?',
            a: 'Podés usar los diseños para probar, mostrar, tomar pedidos y recién después producir. Primero validás. Después invertís.'
          }, {
            q: 'No quiero tirar plata',
            a: 'Por eso esto no es una apuesta a ciegas. Probás, ves cómo funciona y decidís tranquila. Sin presión, sin riesgo innecesario.'
          }].map((item, idx) => <div key={idx} className="flex flex-col md:flex-row gap-6 items-start p-6 rounded-2xl bg-white border border-gray-200 shadow-sm" data-id="element-121">
                <div className="md:w-1/3" data-id="element-122">
                  <h3 className="text-lg font-bold text-gray-900 italic" data-id="element-123">
                    &quot;{item.q}&quot;
                  </h3>
                </div>
                <div className="md:w-2/3" data-id="element-124">
                  <p className="text-gray-600" data-id="element-125">{item.a}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CATEGORIES SECTION */}
      <section className="bg-[#0F172A] text-white py-20 px-4" data-id="element-126">
        <div className="max-w-6xl mx-auto" data-id="element-127">
          <div className="text-center mb-12" data-id="element-128">
            <h2 className="text-3xl md:text-5xl font-extrabold mb-4 tracking-tight" data-id="element-129">
              EXPLORÁ LAS CATEGORÍAS MÁS VENDIBLES
            </h2>
            <p className="text-lg text-gray-400 max-w-3xl mx-auto" data-id="element-130">
              Más de 100.000 diseños organizados en carpetas listas para usar
              con las temáticas más buscadas para sublimación.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12" data-id="element-131">
            {[{
            name: 'Personajes y Series',
            count: '+15.000 diseños'
          }, {
            name: 'Anime y Cultura Otaku',
            count: '+20.000 diseños'
          }, {
            name: 'Autos, Motos y Motorsport',
            count: '+10.000 diseños'
          }, {
            name: 'Música',
            count: '+8.000 diseños'
          }, {
            name: 'Cultura Pop',
            count: '+9.000 diseños'
          }, {
            name: 'Bordados',
            count: '+3.000 diseños'
          }, {
            name: 'Diseños Religiosos',
            count: '+6.000 diseños'
          }, {
            name: 'Dibujos Animados Clásicos',
            count: '+7.000 diseños'
          }].map((cat, idx) => <motion.div key={idx} className="bg-[#1E293B]/60 border border-[#334155] rounded-xl p-5 text-center hover:border-[#2563EB]/50 transition-colors" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} data-id="element-132">
                <FolderOpen className="w-10 h-10 text-yellow-400 mx-auto mb-3" data-id="element-133" />
                <h3 className="font-bold text-sm md:text-base text-white mb-1 leading-tight" data-id="element-134">
                  {cat.name}
                </h3>
                <p className="text-xs text-gray-400" data-id="element-135">{cat.count}</p>
              </motion.div>)}
          </div>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-136">
            {['Anime', 'Dragon Ball', 'Demon Slayer', 'Rick & Morty', 'Mario Bros', 'Autos deportivos', 'Harley Davidson', 'Gym', 'Rock', 'Cantantes', 'Raperos', 'Cristianos', 'Hello Kitty', 'Frozen', 'Narcos', 'Batman', 'Avengers', 'Dibujos Animados 90s', 'Y muchos más...'].map((tag, idx) => <span key={idx} className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border ${tag === 'Y muchos más...' ? 'bg-[#2563EB]/20 border-[#2563EB]/40 text-[#2563EB]' : 'bg-[#1E293B] border-[#334155] text-gray-300'}`} data-id="element-137">
                {tag !== 'Y muchos más...' && <Check className="w-3 h-3 text-[#2563EB]" data-id="element-138" />}
                {tag}
              </span>)}
          </div>
          <div className="w-full mt-12" data-id="element-139">
            {['https://cdn.magicpatterns.com/uploads/9MZznZ6hXqstGaL1RXVQbe/1.png', 'https://cdn.magicpatterns.com/uploads/nWpGgNPx21Nw71UNfVTHaD/2.png', 'https://cdn.magicpatterns.com/uploads/hyABSRu4Xu4drNtYtm3y7W/3.png', 'https://cdn.magicpatterns.com/uploads/s5vpoNCnMV3LhdsUg1eGPA/4.png', 'https://cdn.magicpatterns.com/uploads/1wMzW4C9u9Z7XyxbwL2mGz/5.png'].map((src, idx) => <img key={idx} src={src} alt={`Diseños preview ${idx + 1}`} className="w-full h-auto block" data-id="element-140" />)}
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="bg-[#0F172A] text-white py-20 px-4" data-id="element-141">
        <div className="max-w-3xl mx-auto text-center border border-[#1E293B] bg-[#1E293B]/50 p-8 md:p-12 rounded-3xl relative overflow-hidden" data-id="element-142">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#2563EB] rounded-full blur-3xl opacity-20" data-id="element-143"></div>
          <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-[#2563EB] rounded-full blur-3xl opacity-20" data-id="element-144"></div>
          <ShieldCheck className="w-16 h-16 text-[#2563EB] mx-auto mb-6" data-id="element-145" />
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-146">
            Probalo sin riesgo
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-147">
            Queremos que te sientas tranquilo al comprar.
            <br data-id="element-148" />
            <br data-id="element-149" />
            Por eso tenés{' '}
            <span className="text-white font-bold" data-id="element-150">
              7 días de garantía
            </span>{' '}
            para probar el pack con calma. Si no es lo que esperabas, nos
            escribís y te devolvemos el 100% de tu dinero, sin preguntas ni
            vueltas.
          </p>
          <p className="text-[#2563EB] font-bold text-xl uppercase tracking-widest" data-id="element-151">
            Simple, justo y transparente.
          </p>
        </div>
      </section>

      {/* PROMISE SECTION */}
      <section className="bg-[#FBF7F0] py-20 px-4" data-id="element-152">
        <div className="max-w-4xl mx-auto text-center" data-id="element-153">
          <h2 className="text-4xl font-bold text-gray-900 mb-8" data-id="element-154">
            La promesa es clara
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-8 mb-12" data-id="element-155">
            <div className="bg-white px-8 py-6 rounded-xl border-l-4 border-[#2563EB] text-left shadow-sm" data-id="element-156">
              <p className="text-xl font-bold text-gray-900" data-id="element-157">
                👉 Nunca más quedarte sin qué vender.
              </p>
            </div>
            <div className="bg-white px-8 py-6 rounded-xl border-l-4 border-[#2563EB] text-left shadow-sm" data-id="element-158">
              <p className="text-xl font-bold text-gray-900" data-id="element-159">
                👉 Empezar a generar ingresos desde el primer día.
              </p>
            </div>
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-160">
            No importa si recién empezás o si ya sublimás hace tiempo.
            <br data-id="element-161" />
            <span className="font-bold text-gray-900" data-id="element-162">
              Si tenés una plancha, esto es para vos.
            </span>
          </p>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="bg-[#0F172A] py-24 px-4 relative overflow-hidden" data-id="element-163">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-7xl" data-id="element-164">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#2563EB] rounded-full blur-[128px] opacity-10" data-id="element-165"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500 rounded-full blur-[128px] opacity-5" data-id="element-166"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-167">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-168">
            <div className="h-full" data-id="element-169">
              <PricingCard name="PACK BASE" icon="🎯" originalPrice="$50.000" price="$19.990" link="https://checkout.ultrapack.digital/cart/47731196231835:1" packImage="https://cdn.magicpatterns.com/uploads/8kVRTLZjhjFo7kpY5fWgAw/PACK1.png" features={['+10.000 diseños listos para imprimir', 'Archivos preparados para sublimación en alta calidad', 'Diseños pensados para vender todo el año', 'Ahorrás horas de búsqueda y prueba-error', 'Acceso inmediato y uso ilimitado']} notIncluded={['No incluye sistema para vender', 'No incluye mockups', 'No incluye guía de arranque', 'No incluye diseños para tazas, almohadas, etc']} data-id="element-170" />
            </div>
            <div className="h-full transform md:-translate-y-4" data-id="element-171">
              <PricingCard name="ULTRAPACK DELUXE" icon="💎" isDeluxe={true} badgeText="🔥 MÁS ELEGIDO" originalPrice="$60.000" price="$26.990" link="https://checkout.ultrapack.digital/cart/47860202569883:1" packImage="https://cdn.magicpatterns.com/uploads/7GoZ7UKfTmkjC9ussZtXAG/PACK2.png" features={['+100.000 diseños listos para imprimir', '+60 categorías organizadas', 'Diseños de tazas', 'Diseños de barbijos', 'Diseños de vasos', 'Diseños varios', 'Imágenes varias para multiuso en HD', 'Acceso a futuras actualizaciones']} bonusFeatures={[{
              title: '👕 Mockups listos para vender',
              items: ['Remeras lisas (blanca y negra)', 'Tazas lisas clásicas', 'Fondo limpio y profesional', 'Listos para aplicar diseños y publicar']
            }, {
              title: '📄 Sistema simple Vendé sin stock',
              items: ['Cómo tomar pedidos', 'Cómo cobrar antes', 'Cómo producir después', 'Método de bajo riesgo y mínima inversión']
            }, {
              title: '✅ Checklist Primeras 48 horas',
              items: ['Qué hacer hoy', 'Qué publicar', 'Qué vender primero', 'Pasos claros para empezar sin trabarte']
            }]} data-id="element-172" />
            </div>
            <div className="h-full" data-id="element-173">
              <PricingCard name="ULTRAPACK VIP" icon="⚡" isVip={true} originalPrice="$80.000" price="$39.990" link="https://checkout.ultrapack.digital/cart/47873616445595:1" packImage="https://cdn.magicpatterns.com/uploads/3N19shY8C7fEm86JF2N3xF/PACK3.png" features={['Todo lo del Ultrapack Deluxe, y además:']} bonusFeatures={[{
              title: '✉️ Tarjetas de negocio editables',
              items: ['Plantillas listas para presentarte de forma profesional y generar más confianza en cada venta']
            }, {
              title: '🔤 Pack con +120.000 fuentes tipográficas',
              items: ['Gran variedad de tipografías para personalizar diseños y diferenciarte del resto']
            }, {
              title: '🎨 Pack con +1.000 texturas profesionales (.CDR)',
              items: ['Texturas editables para dar más estilo y profundidad a tus diseños']
            }]} data-id="element-174" />
            </div>
          </div>
        </div>
      </section>

      {/* URGENCY SECTION */}
      <section className="bg-gradient-to-b from-[#1E293B] to-[#0F172A] py-20 px-4 border-y border-[#1E293B]" data-id="element-175">
        <div className="max-w-4xl mx-auto" data-id="element-176">
          <motion.div className="flex justify-center mb-8" initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-177">
            <div className="inline-flex items-center gap-2 bg-[#2563EB]/10 border border-[#2563EB]/30 px-4 py-2 rounded-full" data-id="element-178">
              <Lock className="w-4 h-4 text-[#2563EB]" data-id="element-179" />
              <span className="text-[#2563EB] font-bold text-sm uppercase tracking-wider" data-id="element-180">
                Acceso Limitado · Disponible Hoy
              </span>
            </div>
          </motion.div>
          <motion.h2 className="text-3xl md:text-5xl font-extrabold text-white text-center mb-4 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-181">
            Este precio especial no va a estar disponible por mucho tiempo
          </motion.h2>
          <motion.p className="text-xl text-gray-400 text-center mb-12" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-182">
            Última oportunidad para acceder a esta oferta
          </motion.p>
          <motion.div className="flex justify-center gap-4 mb-12" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-183">
            <div className="bg-[#1E293B]/50 border border-[#2563EB]/30 rounded-2xl p-6 min-w-[120px] text-center backdrop-blur-sm" data-id="element-184">
              <motion.div className="text-5xl md:text-6xl font-bold text-[#2563EB] mb-2" key={timeLeft.minutes} initial={{
              scale: 1.2,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              duration: 0.3
            }} data-id="element-185">
                {String(timeLeft.minutes).padStart(2, '0')}
              </motion.div>
              <div className="text-gray-400 text-sm uppercase tracking-wider" data-id="element-186">
                Minutos
              </div>
            </div>
            <div className="flex items-center text-4xl text-[#2563EB] font-bold" data-id="element-187">
              :
            </div>
            <div className="bg-[#1E293B]/50 border border-[#2563EB]/30 rounded-2xl p-6 min-w-[120px] text-center backdrop-blur-sm" data-id="element-188">
              <motion.div className="text-5xl md:text-6xl font-bold text-[#2563EB] mb-2" key={timeLeft.seconds} initial={{
              scale: 1.2,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              duration: 0.3
            }} data-id="element-189">
                {String(timeLeft.seconds).padStart(2, '0')}
              </motion.div>
              <div className="text-gray-400 text-sm uppercase tracking-wider" data-id="element-190">
                Segundos
              </div>
            </div>
          </motion.div>
          <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-191">
            <div className="flex items-center gap-3 bg-[#1E293B]/30 p-4 rounded-xl border border-[#1E293B]" data-id="element-192">
              <Zap className="w-6 h-6 text-[#2563EB] flex-shrink-0" data-id="element-193" />
              <span className="text-gray-300 text-sm" data-id="element-194">
                Acceso inmediato al contenido
              </span>
            </div>
            <div className="flex items-center gap-3 bg-[#1E293B]/30 p-4 rounded-xl border border-[#1E293B]" data-id="element-195">
              <CreditCard className="w-6 h-6 text-[#2563EB] flex-shrink-0" data-id="element-196" />
              <span className="text-gray-300 text-sm" data-id="element-197">
                Compra protegida con Mercado Pago
              </span>
            </div>
            <div className="flex items-center gap-3 bg-[#1E293B]/30 p-4 rounded-xl border border-[#1E293B]" data-id="element-198">
              <ShieldCheck className="w-6 h-6 text-[#2563EB] flex-shrink-0" data-id="element-199" />
              <span className="text-gray-300 text-sm" data-id="element-200">
                Garantía de devolución
              </span>
            </div>
          </motion.div>
          <motion.div className="text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} data-id="element-201">
            <button onClick={scrollToPricing} className="bg-[#2563EB] text-white text-xl font-bold py-6 px-12 rounded-full shadow-2xl hover:bg-[#1D4ED8] hover:scale-105 transition-all duration-300 inline-flex items-center gap-3" data-id="element-202">
              Quiero asegurar mi acceso ahora <ArrowRight className="w-6 h-6" data-id="element-203" />
            </button>
          </motion.div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="bg-[#FBF7F0] py-20 px-4" data-id="element-204">
        <div className="max-w-3xl mx-auto" data-id="element-205">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12" data-id="element-206">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-2" data-id="element-207">
            <FAQItem question="¿Los diseños tienen marca de agua?" answer="No. Todos los archivos están limpios, en alta calidad y listos para uso comercial." data-id="element-208" />
            <FAQItem question="¿Tiene garantía?" answer="Sí. Tenés garantía de satisfacción para comprar tranquilo usando Mercado Pago" data-id="element-209" />
            <FAQItem question="¿El acceso es inmediato?" answer="Sí. Una vez completada la compra, accedés al contenido al instante." data-id="element-210" />
            <FAQItem question="¿Puedo usar los diseños para vender mis productos?" answer="Sí. Podés imprimir y vender los productos que hagas con los diseños sin problema." data-id="element-211" />
          </div>
        </div>
      </section>

      {/* FINAL CLOSING SECTION */}
      <section className="bg-[#0F172A] py-16 px-4 border-t border-[#1E293B]" data-id="element-212">
        <div className="max-w-4xl mx-auto text-center" data-id="element-213">
          <button onClick={scrollToPricing} className="bg-[#2563EB] text-white text-xl font-bold py-5 px-16 rounded-full shadow-2xl hover:bg-[#1D4ED8] hover:scale-105 transition-all duration-300" data-id="element-214">
            Descargar Ultrapack Ahora
          </button>
        </div>
      </section>

      <footer className="bg-[#0F172A] py-8 text-center text-gray-400 text-sm border-t border-[#1E293B]" data-id="element-215">
        <p data-id="element-216">
          © {new Date().getFullYear()} Ultrapack Sublimador. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}